'use client';

import { Provider } from 'react-redux';
import { store } from '.';
import { persistStore } from 'redux-persist';
import { ReactElement } from 'react';
persistStore(store); // persist the store

export default function ReduxProvider({
  children
}: {
  children: React.ReactNode;
}): ReactElement {
  return <Provider store={store} data-sentry-element="Provider" data-sentry-component="ReduxProvider" data-sentry-source-file="ReduxProvider.tsx">{children}</Provider>;
}